import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { env } from "@/config/env";
import { ThemeProvider } from "@/lib/theme-context";
import { usePageTracking } from "@/hooks/useAnalytics";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MaintenancePage from "@/components/MaintenancePage";
import Home from "@/pages/Home";
import SubmitAgentCompact from "@/pages/SubmitAgentCompact";
import SubmitAgentManual from "@/pages/SubmitAgentManual";
import AgentDetail from "@/pages/AgentDetail";
import Documentation from "@/pages/Documentation";
import Guidelines from "@/pages/Guidelines";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function AppContent() {
  // Track page views automatically
  usePageTracking();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/submit" element={<SubmitAgentCompact />} />
          <Route path="/submit-manual" element={<SubmitAgentManual />} />
          <Route path="/agent/:id" element={<AgentDetail />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/guidelines" element={<Guidelines />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  // Check if maintenance mode is enabled
  const isMaintenanceMode = env.MAINTENANCE_MODE;

  // If maintenance mode is enabled, show only the maintenance page
  if (isMaintenanceMode) {
    return (
      <ThemeProvider>
        <div className="min-h-screen bg-background text-foreground">
          <MaintenancePage />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
